var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOn = function SvgStarOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.681,
    height: 29.365,
    viewBox: "0 0 8.118 7.77"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m241.179 188.339-4.56-2.372-4.538 2.412.846-5.07-3.696-3.57 5.083-.762 2.254-4.619 2.295 4.599 5.089.716-3.664 3.604z",
    style: {
      fill: "var(--primary_color)",
      fillOpacity: 1,
      stroke: "#919191",
      strokeWidth: 0.231,
      strokeDasharray: "none",
      strokeOpacity: 0.517677
    },
    transform: "matrix(.46054 0 0 .46054 -104.939 -79.582)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "var(--primary_color)",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.01517 0 0 .01517 -.311 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528.1 171.5 382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6M388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2z"
  }))));
};
export default SvgStarOn;